// extracted by mini-css-extract-plugin
export default {"logout":"NavigationLogoutItem-WQjJ-__logout","text":"NavigationLogoutItem-THhVZ__text"};